export const preproduction = {
  SECURED_ROOT_SUBDOMAIN: 'premotos.',
  SECURED_API_ROUTE: '/api-web',
  HOST_NAME_SUBDOMAIN: 'premotos.',
  GIGYA_API_KEY: '3_ZEjfgjy-NnSNTswrtxqOd7fBfF9ctUcxkImekBaBJzxFfVnqAN7kDw24kczglro8', // pre.motos.net
  ADYEN_ORIGIN_KEY:
    'pub.v2.8015614668370377.aHR0cHM6Ly9wcmVtb3Rvcy5jb2NoZXMubmV0.lcBo2q_SXlKY7KhT6QT1KAhtOOTw0m6o5swhvDkxTXY', // https://premotos.coches.net
  GOOGLE_AUTH_API_KEY: '', // https://pre.coches.net
  GOOGLE_MAPS_API_KEY: 'AIzaSyBsl-ANYKSxhAboxCAAkbw0MRXtuEBVBRc'
}

export const production = {
  SECURED_ROOT_SUBDOMAIN: 'motos.',
  SECURED_API_ROUTE: '/api-web',
  HOST_NAME_SUBDOMAIN: 'motos.',
  GIGYA_API_KEY: '3_1jj1TPZ8mJbw5buKcM-EPT1SV4Bta_oy56Yi-Ch7GaGnTZqhWHU_x5tWiick_SEV', // prod.motos.net
  ADYEN_ORIGIN_KEY:
    'pub.v2.1115683727433033.aHR0cHM6Ly9tb3Rvcy5jb2NoZXMubmV0.NWr8ocMWbZldHVXc1cTFWc7Gg5oT33KEhcGkbedYry8', // https://motos.coches.net
  GOOGLE_AUTH_API_KEY: '', // https://www.coches.net
  GOOGLE_MAPS_API_KEY: 'AIzaSyBsl-ANYKSxhAboxCAAkbw0MRXtuEBVBRc'
}

export const test = {
  SECURED_ROOT_SUBDOMAIN: 'premotos.',
  SECURED_API_ROUTE: '/api-web',
  HOST_NAME_SUBDOMAIN: 'testmotos.',
  GIGYA_API_KEY: '3_hEcLaBdSqynv2Kbyfh5iaM_UUq27PPZkCYysEDiyQobrMHmHOdppo1pzEDxHldA2', // parent.dev.motos.net
  ADYEN_ORIGIN_KEY: 'pub.v2.8015614668370377.aHR0cDovL2xvY2FsaG9zdDozMDAw.DFqmNyWY-Bgj4wUxBRvmch_yayZhEK22dn1gXWmyEpI', // http://localhost:3000
  GOOGLE_AUTH_API_KEY: '', // http://localhost:3000
  GOOGLE_MAPS_API_KEY: 'AIzaSyBsl-ANYKSxhAboxCAAkbw0MRXtuEBVBRc'
}

export const development = {
  SECURED_ROOT_SUBDOMAIN: 'premotos.',
  SECURED_API_ROUTE: '/api-web',
  HOST_NAME_SUBDOMAIN: 'devmotos.',
  GIGYA_API_KEY: '3_ZEjfgjy-NnSNTswrtxqOd7fBfF9ctUcxkImekBaBJzxFfVnqAN7kDw24kczglro8', // pre.motos.net
  ADYEN_ORIGIN_KEY: 'pub.v2.8015614668370377.aHR0cDovL2xvY2FsaG9zdDozMDAw.DFqmNyWY-Bgj4wUxBRvmch_yayZhEK22dn1gXWmyEpI', // http://localhost:3000
  GOOGLE_AUTH_API_KEY: '', // https://dev.coches.net
  GOOGLE_MAPS_API_KEY: 'AIzaSyBsl-ANYKSxhAboxCAAkbw0MRXtuEBVBRc'
}
